module.exports = __webpack_public_path__ + "files/6f12f9c4ee8bf45ca3c36c832a7fbcdb.png";